import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class WorkMileageStatisticsApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'WorkMileageStatistics'
  }

}
